export default __webpack_public_path__ + "static/media/close-menu.29057b25.svg";